export { Logo } from './logo';

// Canonical pixel sizes for the Logo component. Reuse these instead of hard-
// coding numbers at call sites so brand sizing stays consistent across the app.
//   primary — landing header, auth layout, chat sidebar (full chrome)
//   compact — mobile drawer, medium contexts
//   inline  — footer / inline accents
export const LOGO_SIZE = {
  large: 124,
  primary: 74,
  compact: 48,
  inline: 24,
} as const;
